import axios from "axios";
import configData from "../../../config.json";
import { alertService } from "components/Varios/alert_service";
import { authHeaderWithUserData } from "helpers/auth-header";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { authenticationService } from "services/authentication.service";
import { ResponseRequestGeneric } from "components/Types/GeneralTypes";
import { hadleAxiosErrorResponse } from "helpers/handle-response";


type DatosRequestReversarEmisionCertificado = {
    idCertificado:number,
    observacion:string
}


export async function ReversarEmisionCertificado(idCertificado:number|undefined,observacion:string){
    const URL_REVERSAR_CERTIFICADO:string =  `${configData.SERVER_URL}GenerarCertificados/Reverso/Certificado`
    const datosUsuario:UserData = authenticationService.currentUserValue;

    var resultado:ResponseRequestGeneric<boolean> = {
        status:-1
    }

    if(observacion === undefined || observacion === ""){
        alertService.error("Para reversar certificado debe indicar una observación");
        return -1;
    }
    else if (idCertificado === undefined){
        alertService.error("Para reversar certificado debe indicar cual certificado desea reversar");
        return -1;
    }


    const datosRequest:DatosRequestReversarEmisionCertificado = {
        idCertificado:idCertificado,
        observacion:observacion
    }

    try {
        const respuesta = await axios.put(URL_REVERSAR_CERTIFICADO,datosRequest,{
            headers: authHeaderWithUserData(datosUsuario)
        })

        const valoreDevuelto:boolean = respuesta.data;

        resultado = {
            status:respuesta.status,
            dataResponse:valoreDevuelto
        }
        alertService.success("El certificado ha sido reversado");

    } catch (error) {
        resultado = hadleAxiosErrorResponse<boolean>(error)      
        alertService.error(resultado.errorMessage??"Ha ocurrido un inconveniente con el reverso del certificado");
    }

    return resultado.status;
    
}